module.exports = __webpack_public_path__ + "static/media/home-card-02.e0830d22.png";